// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2WAu5","label":"SetPasswdForm_label__2qVcv"};